import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const WATCHLIST_DATA = [
  { ticker: 'NVDA', name: 'NVIDIA Corporation', sector: 'Technology', currentPrice: 875.40, changePercent: 3.21, targetPrice: 950.00, notes: 'AI chip leader, strong earnings momentum' },
  { ticker: 'PLTR', name: 'Palantir Technologies', sector: 'Technology', currentPrice: 24.85, changePercent: -1.45, targetPrice: 32.00, notes: 'Government AI contracts expanding' },
  { ticker: 'ENPH', name: 'Enphase Energy', sector: 'Energy', currentPrice: 118.60, changePercent: 0.87, targetPrice: 145.00, notes: 'Solar microinverter market leader' },
  { ticker: 'HIMS', name: 'Hims & Hers Health', sector: 'Healthcare', currentPrice: 18.25, changePercent: 2.14, targetPrice: 25.00, notes: 'Women-led health platform growth' },
  { ticker: 'ABNB', name: 'Airbnb Inc.', sector: 'Consumer', currentPrice: 142.30, changePercent: -0.63, targetPrice: 165.00, notes: 'Travel recovery play, strong cash flow' },
];

export default function WatchlistTab() {
  const [watchlist, setWatchlist] = useState(WATCHLIST_DATA);

  const removeFromWatchlist = (ticker) => setWatchlist(w => w?.filter(s => s?.ticker !== ticker));

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-semibold text-lg md:text-xl" style={{ color: 'var(--color-foreground)' }}>Watchlist</h2>
        <Button variant="outline" size="sm" iconName="Plus" iconPosition="left">Add to Watchlist</Button>
      </div>
      <div className="space-y-3">
        {watchlist?.map((stock) => {
          const isPos = stock?.changePercent >= 0;
          const toTarget = (((stock?.targetPrice - stock?.currentPrice) / stock?.currentPrice) * 100)?.toFixed(1);
          return (
            <div key={stock?.ticker} className="rounded-xl border p-4 transition-all hover:shadow-md"
              style={{ borderColor: 'var(--color-border)', background: 'var(--color-card)' }}>
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ background: 'var(--color-primary)' }}>
                    <span className="font-data font-bold text-xs text-white">{stock?.ticker?.slice(0, 3)}</span>
                  </div>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-data font-bold text-sm" style={{ color: 'var(--color-primary)' }}>{stock?.ticker}</span>
                      <span className="font-caption text-xs px-2 py-0.5 rounded-full" style={{ background: 'var(--color-muted)', color: 'var(--color-muted-foreground)' }}>{stock?.sector}</span>
                    </div>
                    <p className="font-caption text-xs mt-0.5 line-clamp-1" style={{ color: 'var(--color-muted-foreground)' }}>{stock?.name}</p>
                    <p className="font-caption text-xs mt-1 line-clamp-1 italic" style={{ color: 'var(--color-muted-foreground)' }}>{stock?.notes}</p>
                  </div>
                </div>
                <div className="flex flex-col items-end gap-1 flex-shrink-0">
                  <p className="font-data font-bold text-sm" style={{ color: 'var(--color-foreground)' }}>${stock?.currentPrice?.toFixed(2)}</p>
                  <span className={`flex items-center gap-0.5 font-data text-xs font-semibold ${isPos ? 'text-emerald-600' : 'text-red-600'}`}>
                    <Icon name={isPos ? 'ArrowUpRight' : 'ArrowDownRight'} size={12} color="currentColor" />
                    {isPos ? '+' : ''}{stock?.changePercent?.toFixed(2)}%
                  </span>
                  <span className="font-caption text-xs" style={{ color: 'var(--color-accent)' }}>
                    Target: ${stock?.targetPrice} ({toTarget > 0 ? '+' : ''}{toTarget}%)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-3 pt-3 border-t" style={{ borderColor: 'var(--color-border)' }}>
                <Button variant="default" size="xs">Buy Now</Button>
                <Button variant="outline" size="xs">Set Alert</Button>
                <button className="ml-auto p-1.5 rounded-md hover:bg-red-50 transition-colors" onClick={() => removeFromWatchlist(stock?.ticker)} title="Remove from watchlist">
                  <Icon name="Trash2" size={14} color="#DC2626" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}